module.exports = "/assets/site/images/kadosa_laszlo_portfolio.jpg?c7f57a09014544127820cfa86711b519";